module.exports = __webpack_public_path__ + "static/media/03.96f09ec1.jpg";